var _circle, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalindicators(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "url(#paint0_linear_65_73)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_73",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 25,
    width: 50,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 25H66.1111V51H17V25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8958 32.2228C54.2641 27.5798 48.1051 25.0226 41.555 25.0226C35.0268 25.0226 28.8891 27.5623 24.2624 32.1746C24.2586 32.179 24.2536 32.1821 24.2498 32.1865C24.2473 32.189 24.2448 32.1915 24.243 32.194C24.2329 32.2034 24.2229 32.2128 24.2135 32.2228C19.5817 36.8653 17.0308 43.038 17.0308 49.6045C17.0308 50.3637 17.6452 50.9793 18.4025 50.9793H23.4405C24.1984 50.9793 24.8122 50.3637 24.8122 49.6045C24.8122 48.8452 24.1984 48.2296 23.4405 48.2296H19.8168C20.1284 43.2242 22.1302 38.6714 25.2554 35.1381L27.3274 37.2145C27.5958 37.4828 27.9462 37.6169 28.2973 37.6169C28.6484 37.6169 28.9995 37.4828 29.2672 37.2138C29.8032 36.6772 29.8026 35.8064 29.2672 35.2697L27.2002 33.199C30.7147 30.1057 35.2267 28.1271 40.1832 27.8168V30.6869C40.1832 31.4461 40.797 32.0617 41.555 32.0617C42.3123 32.0617 42.9267 31.4461 42.9267 30.6869V27.8168C47.9064 28.1284 52.4378 30.1245 55.9593 33.2429L53.9356 35.2697C53.4002 35.8064 53.4002 36.6772 53.9356 37.2138C54.2033 37.4828 54.5543 37.6169 54.9054 37.6169C55.2565 37.6169 55.6076 37.4828 55.8753 37.2145L57.8984 35.1876C60.9979 38.7134 62.9828 43.248 63.2931 48.2296H59.6601C58.9021 48.2296 58.2883 48.8452 58.2883 49.6045C58.2883 50.3637 58.9021 50.9793 59.6601 50.9793H64.7075C65.4648 50.9793 66.0792 50.3637 66.0792 49.6045C66.0792 43.038 63.5282 36.8653 58.8958 32.2228Z",
    fill: "#00AC4F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_65_73",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 25,
    width: 50,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0084 25H66.1013V51H17.0084V25Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_65_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6602 48.2522C58.916 48.2522 58.3104 48.8585 58.3104 49.6045C58.3104 50.3499 58.916 50.9568 59.6602 50.9568H64.7076C65.4517 50.9568 66.0567 50.3499 66.0567 49.6045C66.0567 43.0443 63.5076 36.8772 58.8803 32.2386C54.2523 27.5999 48.0996 25.0452 41.5551 25.0452C35.0356 25.0452 28.9005 27.583 24.2782 32.1909C24.2757 32.1928 24.2732 32.1953 24.2713 32.1972C24.2694 32.1991 24.2675 32.2003 24.2656 32.2022L24.2293 32.2386C19.6019 36.8772 17.0534 43.0443 17.0534 49.6045C17.0534 50.3499 17.6584 50.9568 18.4026 50.9568H23.4406C24.1848 50.9568 24.7897 50.3499 24.7897 49.6045C24.7897 48.8585 24.1848 48.2522 23.4406 48.2522H19.7931L19.7944 48.2278C19.9473 45.7727 20.5078 43.3822 21.4608 41.1234C22.3848 38.9317 23.6556 36.9129 25.2386 35.1231L25.2543 35.1055L27.3432 37.1988C27.5984 37.454 27.9369 37.5944 28.2974 37.5944C28.6579 37.5944 28.9971 37.454 29.2516 37.1982C29.7776 36.671 29.7776 35.8127 29.2516 35.2861L27.1677 33.1978L27.1859 33.1821C28.9651 31.616 30.9694 30.3578 33.1423 29.4437C35.3811 28.5014 37.7502 27.9466 40.1821 27.7943L40.2059 27.793V30.6869C40.2059 31.433 40.8109 32.0392 41.5551 32.0392C42.2986 32.0392 42.9042 31.433 42.9042 30.6869V27.793L42.9281 27.7943C45.3712 27.9472 47.7504 28.5065 49.9986 29.4569C52.1803 30.3785 54.1908 31.6467 55.9738 33.226L55.992 33.2417L53.9513 35.2861C53.4254 35.8127 53.4254 36.671 53.9513 37.1982C54.2059 37.454 54.545 37.5944 54.9055 37.5944C55.266 37.5944 55.6046 37.454 55.8597 37.1988L57.8991 35.155L57.9148 35.1726C59.4852 36.9587 60.746 38.9712 61.6626 41.1541C62.6073 43.4042 63.1634 45.784 63.3152 48.2278L63.317 48.2522H59.6602ZM64.7076 51.0013H59.6602C58.8915 51.0013 58.2659 50.375 58.2659 49.6045C58.2659 48.834 58.8915 48.2071 59.6602 48.2071H63.2694C62.9628 43.3678 61.1052 38.8777 57.8972 35.2202L55.8911 37.2302C55.6278 37.4941 55.2779 37.6396 54.9055 37.6396C54.5331 37.6396 54.1833 37.4941 53.92 37.2302C53.3764 36.6847 53.3764 35.7989 53.92 35.2541L55.9268 33.2442C52.2743 30.0167 47.7874 28.1485 42.9487 27.8407V30.6869C42.9487 31.4574 42.3237 32.0843 41.5551 32.0843C40.7865 32.0843 40.1608 31.4574 40.1608 30.6869V27.8407C35.346 28.1472 30.8766 29.9998 27.2329 33.2003L29.2829 35.2541C29.8265 35.7989 29.8265 36.6854 29.2836 37.2302C29.0203 37.4941 28.6698 37.6396 28.2974 37.6396C27.925 37.6396 27.5752 37.4941 27.3119 37.2302L25.2562 35.1707C22.067 38.785 20.1442 43.4129 19.8408 48.2071H23.4406C24.2092 48.2071 24.8349 48.834 24.8349 49.6045C24.8349 50.375 24.2092 51.0013 23.4406 51.0013H18.4026C17.634 51.0013 17.0083 50.375 17.0083 49.6045C17.0083 43.0324 19.5618 36.854 24.1979 32.2066L24.2268 32.1784C24.2305 32.174 24.2324 32.1721 24.2337 32.1709C24.2368 32.1677 24.2393 32.1658 24.2418 32.1633L24.2468 32.1589C28.8773 27.5429 35.0244 25.0007 41.5551 25.0007C48.1115 25.0007 54.2755 27.5598 58.9116 32.2066C63.5484 36.854 66.1012 43.0324 66.1012 49.6045C66.1012 50.375 65.4762 51.0013 64.7076 51.0013Z",
    fill: "#00AC4F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_65_73",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 35,
    width: 7,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4553 35.1769H44.5541V51H38.4553V35.1769Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_65_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5548 35.2146C41.3629 35.2146 41.1974 35.3494 41.1586 35.5381L38.5919 47.9613C38.5919 49.6283 39.9185 50.9793 41.5548 50.9793C43.1904 50.9793 44.517 49.6283 44.517 47.9613L41.9504 35.5381C41.9115 35.3494 41.7466 35.2146 41.5548 35.2146Z",
    fill: "#00AC4F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_65_73",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 35,
    width: 7,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5576 35.1769H44.5542V51H38.5576V35.1769Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_65_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6148 47.9638C38.6161 49.6139 39.9345 50.9567 41.5551 50.9567C43.1751 50.9567 44.4942 49.6139 44.4954 47.9638L41.9288 35.5424C41.8924 35.3656 41.7351 35.2371 41.5551 35.2371C41.3746 35.2371 41.2172 35.3656 41.1809 35.5424L38.6148 47.9638ZM41.5551 51.0013C39.9088 51.0013 38.5697 49.6377 38.5697 47.9613L38.5703 47.9569L41.137 35.533C41.1777 35.3356 41.3539 35.192 41.5551 35.192C41.7564 35.192 41.9319 35.3356 41.9727 35.533L44.5399 47.9588V47.9613C44.5399 49.6377 43.2008 51.0013 41.5551 51.0013Z",
    fill: "#00AC4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_73",
    x1: 74.55,
    y1: 0.00000214197,
    x2: 42,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFFF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalindicators);
export default __webpack_public_path__ + "static/media/Total indicators.c83d8104542258cd12fc3a76efcb2cd2.svg";
export { ForwardRef as ReactComponent };